// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Rubik_382a4e', '__Rubik_Fallback_382a4e'","fontStyle":"normal"},"className":"__className_382a4e"};